import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, withCtx as _withCtx } from "vue";
const _hoisted_1 = {
  class: "page",
  id: "page"
};
const _hoisted_2 = {
  class: "section-md bg-transparent"
};
const _hoisted_3 = {
  class: "container"
};
const _hoisted_4 = {
  class: "row row-30 row-xl-55 row-xxl-100 justify-content-between"
};
const _hoisted_5 = {
  style: {
    "color": "#b28e5c",
    "font-weight": "bold"
  }
};
const _hoisted_6 = ["innerHTML"];
const _hoisted_7 = {
  class: "col-md-4 col-xl-4"
};
const _hoisted_8 = {
  class: "list list-divided list-divided-sm big"
};
const _hoisted_9 = ["onClick"];
import { ref, onMounted, computed } from 'vue';
import { useRoute } from 'vue-router';
import { territoryInfo, territoryList as territoryListHttp } from '@/api/territory';
import { bannerList as bannerListHttp } from '@/api/home';

import { ElMessage } from 'element-plus/es';
import 'element-plus/es/components/base/style/css';
import 'element-plus/es/components/message/style/css';
export default {
  __name: 'territory',
  setup(__props) {
    const route = useRoute();
    const path = computed(() => {
      return process.env.VUE_APP_BASE_ADDRESS;
    });
    const info = ref(null);
    const scrollbarRef = ref(null);
    const territoryIdFromUrl = ref(null);
    const territoryContent = ref(null);

    // 顶部图片
    const bg = ref('');
    const getBanner = async () => {
      const data = await bannerListHttp({
        type: 'territory'
      });
      if (data?.length > 0) {
        for (const item of data) {
          if (!item.src.startsWith('http')) item.src = path.value + item.src;
        }
        bg.value = data[0]?.src;
      }
    };
    const getData = async (id = '') => {
      const territoryId = id || route.query.id;
      territoryIdFromUrl.value = territoryId;
      if (!territoryId) {
        return ElMessage.error('参数错误');
      }
      const data = await territoryInfo(territoryId);
      territoryContent.value?.classList.add('animated', 'fadeOut');
      setTimeout(() => {
        scrollbarRef.value?.setScrollTop(0);
        info.value = data;
        console.log('***');
        territoryContent.value?.classList.remove('fadeOut');
        territoryContent.value?.classList.add('fadeIn');
      }, 300);
    };

    // 专业领域
    const territoryList = ref([]);
    const getTerritory = async () => {
      return territoryListHttp().then(res => {
        territoryList.value = res || [];
        return res;
      });
    };
    onMounted(async () => {
      // 顶部图片
      getBanner();
      await getTerritory().then(res => {
        if (!route.query?.id) {
          getData(res[0].id);
        } else {
          getData();
        }
      });
    });
    return (_ctx, _cache) => {
      const _component_Preload = _resolveComponent("Preload");
      const _component_Header = _resolveComponent("Header");
      const _component_router_link = _resolveComponent("router-link");
      const _component_Footer = _resolveComponent("Footer");
      return _openBlock(), _createElementBlock(_Fragment, null, [_createVNode(_component_Preload), _createElementVNode("div", _hoisted_1, [_createVNode(_component_Header, {
        title: "冀华专业",
        bg: bg.value
      }, null, 8, ["bg"]), _createElementVNode("section", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createElementVNode("div", {
        class: "col-md-8",
        ref_key: "territoryContent",
        ref: territoryContent,
        "data-animate": "{\"class\":\"fadeInUpBig\"}"
      }, [_createElementVNode("h3", _hoisted_5, _toDisplayString(info.value?.name), 1), _createElementVNode("h5", {
        innerHTML: info.value?.content
      }, null, 8, _hoisted_6)], 512), _createElementVNode("div", _hoisted_7, [_cache[1] || (_cache[1] = _createElementVNode("h3", {
        class: "text-primary"
      }, "专业领域", -1)), _createElementVNode("ul", _hoisted_8, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(territoryList.value, item => {
        return _openBlock(), _createElementBlock("li", {
          class: "list-item",
          key: item.id
        }, [_createElementVNode("a", {
          class: _normalizeClass(["link link-arrow", territoryIdFromUrl.value == item.id ? 'link-hover' : '']),
          onClick: $event => getData(item.id)
        }, _toDisplayString(item.name), 11, _hoisted_9)]);
      }), 128))]), _createVNode(_component_router_link, {
        class: "btn btn-block",
        to: "/contact-us"
      }, {
        default: _withCtx(() => _cache[0] || (_cache[0] = [_createTextVNode("联系我们")])),
        _: 1
      })])])])]), _createVNode(_component_Footer)])], 64);
    };
  }
};